/* Created by Interactive 63 - https://interactive63.com */
/**
 * The curated easing library offered by the easing editor: named cubic Béziers (the familiar
 * sine, quad, cubic, quart, quint, expo, circ and back families, plus two house curves) and
 * spring presets. Values are stored as plain cubic control points so they export as ordinary
 * CSS.
 */

export type BezierValues = readonly [x1: number, y1: number, x2: number, y2: number];

export interface NamedCurve {
  id: string;
  label: string;
  values: BezierValues;
}

export const NAMED_CURVES: readonly NamedCurve[] = [
  { id: 'sine-in', label: 'Sine in', values: [0.12, 0, 0.39, 0] },
  { id: 'sine-out', label: 'Sine out', values: [0.61, 1, 0.88, 1] },
  { id: 'sine-in-out', label: 'Sine in-out', values: [0.37, 0, 0.63, 1] },
  { id: 'quad-in', label: 'Quad in', values: [0.11, 0, 0.5, 0] },
  { id: 'quad-out', label: 'Quad out', values: [0.5, 1, 0.89, 1] },
  { id: 'quad-in-out', label: 'Quad in-out', values: [0.45, 0, 0.55, 1] },
  { id: 'cubic-in', label: 'Cubic in', values: [0.32, 0, 0.67, 0] },
  { id: 'cubic-out', label: 'Cubic out', values: [0.33, 1, 0.68, 1] },
  { id: 'cubic-in-out', label: 'Cubic in-out', values: [0.65, 0, 0.35, 1] },
  { id: 'quart-in', label: 'Quart in', values: [0.5, 0, 0.75, 0] },
  { id: 'quart-out', label: 'Quart out', values: [0.25, 1, 0.5, 1] },
  { id: 'quart-in-out', label: 'Quart in-out', values: [0.76, 0, 0.24, 1] },
  { id: 'quint-in', label: 'Quint in', values: [0.64, 0, 0.78, 0] },
  { id: 'quint-out', label: 'Quint out', values: [0.22, 1, 0.36, 1] },
  { id: 'quint-in-out', label: 'Quint in-out', values: [0.83, 0, 0.17, 1] },
  { id: 'expo-in', label: 'Expo in', values: [0.7, 0, 0.84, 0] },
  { id: 'expo-out', label: 'Expo out', values: [0.16, 1, 0.3, 1] },
  { id: 'expo-in-out', label: 'Expo in-out', values: [0.87, 0, 0.13, 1] },
  { id: 'circ-in', label: 'Circ in', values: [0.55, 0, 1, 0.45] },
  { id: 'circ-out', label: 'Circ out', values: [0, 0.55, 0.45, 1] },
  { id: 'circ-in-out', label: 'Circ in-out', values: [0.85, 0, 0.15, 1] },
  { id: 'back-in', label: 'Back in', values: [0.36, 0, 0.66, -0.56] },
  { id: 'back-out', label: 'Back out', values: [0.34, 1.56, 0.64, 1] },
  { id: 'back-in-out', label: 'Back in-out', values: [0.68, -0.6, 0.32, 1.6] },
  { id: 'snappy', label: 'Snappy', values: [0.2, 0.9, 0.1, 1] },
  { id: 'gentle', label: 'Gentle', values: [0.4, 0, 0.2, 1] },
];

export interface SpringPreset {
  id: string;
  label: string;
  stiffness: number;
  damping: number;
  mass: number;
}

export const SPRING_PRESETS: readonly SpringPreset[] = [
  { id: 'gentle', label: 'Gentle', stiffness: 120, damping: 14, mass: 1 },
  { id: 'wobbly', label: 'Wobbly', stiffness: 180, damping: 12, mass: 1 },
  { id: 'stiff', label: 'Stiff', stiffness: 210, damping: 20, mass: 1 },
  { id: 'slow', label: 'Slow', stiffness: 280, damping: 60, mass: 1 },
  { id: 'default', label: 'Default', stiffness: 170, damping: 26, mass: 1 },
];
